import types from './types';
import actions from './actions';
import reducers from './reducers';
import services from './services';

export default {
  types,
  actions,
  reducers,
  services,
}